// eslint-disable-next-line
// @ts-nocheck
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Tooltip,
  Switch,
  Modal,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListHead, BookingListToolbar } from '../../sections/@dashboard/bookings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  useDeleteServiceProviderDetailMutation,
  useGetAllServiceProviderDetailMutation,
  useUpdateServiceProviderDetailMutation,
} from '../../store/api/serviceProviderApi';
import {
  getInActiveServiceProviderSpaces,
  getServiceProviderDetails,
  getServiceProviderTotalRecords,
  setServiceProvider,
} from '../../store/state/serviceProviderSlice';
import ArrowCircleDownOutlinedIcon from '@mui/icons-material/ArrowCircleDownOutlined';
import toast from 'react-hot-toast';

const TABLE_HEAD = [
  { id: 'vendorName', label: 'Vendor Name', alignRight: false },
  { id: 'status', label: "Vendor's Status", alignRight: false },
  // { id: 'DownloadW9', label: 'Download W9 ', alignRight: false },
  // { id: 'DownloadContract', label: 'Download Vendor Contract ', alignRight: false },
  { id: 'Action', label: 'Action', alignRight: false },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ViewRequests() {
  const parkingSpacesData = useAppSelector(getServiceProviderDetails);
  const [getAllServiceProviderDetail, getAllResponse] = useGetAllServiceProviderDetailMutation();
  const [updateServiceProviderDetail, updateServiceProviderDetailResponse] = useUpdateServiceProviderDetailMutation();
  const [parkingSpaces, setParkingSpaces] = useState([]);
  const token = JSON.parse(localStorage.getItem('login')) || null;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('desc');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [value, setValue] = useState(0);
  const [offset, setOffset] = useState(5);
  const [columName, setColumName] = useState('id');
  const serviceProviderTotalRecords = useAppSelector(getServiceProviderTotalRecords);
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - parkingSpaces.length) : 0;
  const filteredUsers = parkingSpaces;
  const isUserNotFound = filteredUsers.length === 0;

  useEffect(() => {
    if (parkingSpacesData) {
      setParkingSpaces(parkingSpacesData);
    }
  }, [parkingSpacesData]);

  useEffect(() => {
    getAllServiceProviderDetail({
      token: token.token,
      payload: {
        page: page,
        offset: offset,
        orderBy: orderBy,
        columName: columName,
        currentStatus: 'Pending',
      },
    });
  }, [getAllServiceProviderDetail]);

  useEffect(() => {
    if (getAllResponse.isSuccess) {
      dispatch(setServiceProvider(getAllResponse.data));
    }

    if (getAllResponse.isError) {
      let errorData: any = getAllResponse.error;
      let msg: any = errorData.data.serviceErrors[0].msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [getAllResponse.isSuccess, getAllResponse.isError]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = parkingSpaces.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllServiceProviderDetail({
      token: token.token,
      payload: {
        page: newPage,
        offset: offset,
        orderBy: orderBy,
        columName: columName,
        currentStatus: 'Pending',
      },
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setOffset(event.target.value);
    setPage(0);
    getAllServiceProviderDetail({
      token: token.token,
      payload: {
        page: 0,
        offset: parseInt(event.target.value, 10),
        orderBy: orderBy,
        columName: columName,
        currentStatus: 'Pending',
      },
    });
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
      getAllServiceProviderDetail({
        token: token.token,
        payload: {
          page: page,
          offset: offset,
          orderBy: orderBy,
          columName: columName,
          name: event.target.value,
          currentStatus: 'Pending',
        },
      });
  };

  const handleClick = (
    id,
    address,
    businessName,
    city,
    commission,
    companyTypeList,
    contactNumber,
    contractFilePath,
    contractFileUrl,
    country,
    einNumber,
    emailId,
    exemptFatca,
    filePath,
    fileUrl,
    gstNo,
    llcTaxType,
    merchantId,
    name,
    other,
    payeeCode,
    primaryAccountNo,
    socialSecNumber,
    state,
    status,
    stripeAccountId,
    tierType,
    userId,
    vatNo,
    vendorAlias,
    zip
  ) => {
    updateServiceProviderDetail({
      token: token.token,
      payload: {
        address: address,
        businessName: businessName,
        city: city,
        commission: commission,
        companyTypeList: companyTypeList,
        contactNumber: contactNumber,
        contractFilePath: contractFilePath,
        country: country,
        currentStatus: 'Denied',
        einNumber: einNumber,
        emailId: emailId,
        exemptFatca: exemptFatca,
        filePath: filePath,
        gstNo: gstNo,
        id: id,
        llcTaxType: llcTaxType,
        merchantId: merchantId,
        name: name,
        other: other,
        password: '',
        payeeCode: payeeCode,
        primaryAccountNo: primaryAccountNo,
        requestFrom: '',
        sendEmail: '',
        socialSecNumber: socialSecNumber,
        state: state,
        status: status,
        stripeAccountId: stripeAccountId,
        stripeUrl: '',
        tierType: tierType,
        userId: userId,
        vatNo: vatNo,
        vendorAlias: vendorAlias,
        zip: zip,
        sendEmail: false,
      },
    });
  };

  useEffect(() => {
    if (updateServiceProviderDetailResponse.isSuccess) {
      toast.success('Vendor request denied successfully');
      getAllServiceProviderDetail({
        token: token.token,
        payload: {
          page: page,
          offset: offset,
          orderBy: orderBy,
          columName: columName,
          currentStatus: 'Pending',
        },
      });
    } else if (updateServiceProviderDetailResponse.isError) {
      let errorData: any = updateServiceProviderDetailResponse.error;
      let msg: any = errorData.data.serviceErrors[0].msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [updateServiceProviderDetailResponse.isSuccess, updateServiceProviderDetailResponse.isError]);

  return (
    <Page title="Vendor's Status">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h4" gutterBottom>
            Vendor Request
          </Typography>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              navigate('/dashboard/vendor-details', { replace: true });
            }}
            sx={{ marginBottom: '10px' }}
            size="medium"
          >
            <ArrowBackIcon />
          </Button>
        </Stack>
        <Card>
          <BookingListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            placeholder={'Search Vendor Name'}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <BookingListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={parkingSpaces.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.length > 0 &&
                    filteredUsers.map((row) => {
                      const {
                        id,
                        address,
                        businessName,
                        city,
                        commission,
                        companyTypeList,
                        contactNumber,
                        contractFilePath,
                        country,
                        einNumber,
                        emailId,
                        exemptFatca,
                        filePath,
                        gstNo,
                        llcTaxType,
                        merchantId,
                        name,
                        other,
                        payeeCode,
                        primaryAccountNo,
                        socialSecNumber,
                        state,
                        status,
                        stripeAccountId,
                        tierType,
                        userId,
                        vatNo,
                        zip,
                        vendorAlias,
                        currentStatus,
                        contractFileUrl,
                        fileUrl,
                      } = row;
                      const isItemSelected = selected.indexOf(name) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Button
                                onClick={() => {
                                  navigate('/dashboard/add-vendor', {
                                    state: {
                                      isApproved: true,
                                      id: row.id,
                                    },
                                  });
                                }}
                              >
                                <Typography variant="subtitle2" noWrap pl={2}>
                                  {vendorAlias ? vendorAlias : name}{' '}
                                </Typography>
                              </Button>
                            </Stack>
                          </TableCell>
                          <TableCell align="left">
                            <Label variant="ghost" color={'error'}>
                              {currentStatus}
                            </Label>
                          </TableCell>
                          {/* <TableCell align="left">
                            <Button
                              style={{
                                textDecoration: 'none',
                                color: fileUrl === null ? 'lightgray' : 'blue',
                                border: 'none',
                                background: 'none',
                              }}
                              disabled={fileUrl == null ? true : false}
                              href={fileUrl}
                              target="_blank"
                            >
                              <Tooltip title="W-9">
                                <ArrowCircleDownOutlinedIcon />
                              </Tooltip>
                            </Button>
                          </TableCell>
                          <TableCell align="left">
                            <Button
                              style={{
                                textDecoration: 'none',
                                color: contractFileUrl === null ? 'lightgray' : 'blue',
                                border: 'none',
                                background: 'none',
                              }}
                              disabled={contractFileUrl == null ? true : false}
                              href={contractFileUrl}
                              target="_blank"
                            >
                              <Tooltip title="Contract">
                                <ArrowCircleDownOutlinedIcon />
                              </Tooltip>
                            </Button>
                          </TableCell> */}
                          <TableCell align="left">
                            <Button
                              style={{ backgroundColor: 'red' }}
                              variant="contained"
                              onClick={() =>
                                handleClick(
                                  id,
                                  address,
                                  businessName,
                                  city,
                                  commission,
                                  companyTypeList,
                                  contactNumber,
                                  contractFilePath,
                                  contractFileUrl,
                                  country,
                                  einNumber,
                                  emailId,
                                  exemptFatca,
                                  filePath,
                                  fileUrl,
                                  gstNo,
                                  llcTaxType,
                                  merchantId,
                                  name,
                                  other,
                                  payeeCode,
                                  primaryAccountNo,
                                  socialSecNumber,
                                  state,
                                  status,
                                  stripeAccountId,
                                  tierType,
                                  userId,
                                  vatNo,
                                  vendorAlias,
                                  zip
                                )
                              }
                            >
                              Deny
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={serviceProviderTotalRecords || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}
